// components/ui/Copyable.jsx
//
// Envuelve un contenido para copiarlo al portapapeles con un clic. Se usa para
// el folio del ticket y el ID del solicitante, para compartirlos rápido. Es un
// <span> (no <button>) para conservar el estilo del elemento que envuelve
// (folio grande, tag), pero con role/teclado para accesibilidad.
import React from 'react';
import { toast } from 'react-toastify';

const CopyIcon = () => (
    <svg width="0.72em" height="0.72em" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         style={{ opacity: 0.55, marginLeft: 5, flexShrink: 0 }} aria-hidden="true">
        <rect x="9" y="9" width="11" height="11" rx="2" />
        <path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </svg>
);

export default function Copyable({ value, mensaje = 'Copiado', title = 'Clic para copiar', className = '', style, children }) {
    const copiar = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            await navigator.clipboard.writeText(String(value ?? ''));
            toast.success(mensaje);
        } catch {
            toast.error('No se pudo copiar');
        }
    };
    return (
        <span
            role="button"
            tabIndex={0}
            className={className}
            title={title}
            onClick={copiar}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') copiar(e); }}
            style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', ...style }}
        >
            {children}<CopyIcon />
        </span>
    );
}
